import React, { useState, useEffect } from 'react';
import MMProductList from './MMProductList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable, faTh, faGripHorizontal, faRectangleList, faThLarge, faChartLine, faChartArea, faChartBar, faArrowsAltV, faChartPie, faBuilding, faWallet, faCalendarAlt, faArrowUp, faArrowDown, faPiggyBank, faPercentage, faShieldAlt, faBoxes, faInfoCircle, faUmbrella, faHeartbeat, faCoins, faCar, faMotorcycle, faUsers, faPlane, faFemale, faChild, faUserShield, faHome, faBalanceScale } from '@fortawesome/free-solid-svg-icons';
import { faClock, faDollarSign, faIndianRupee} from '@fortawesome/free-solid-svg-icons';
import EnquiryForm from './MmEnquary';
import NFOList from './NFOList';
import CalculatorList from './CalculatorList';
import IndexChart from './IndexChart';
import { fetchWithRetry } from './utils/api';
// import CategorySnapshot from './CategorySnapshot';

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  const options = { day: '2-digit', month: 'short', year: '2-digit' };
  return date.toLocaleDateString('en-GB', options);
};

const getBackgroundColor = (percentage) => {
  const intensity = Math.min(Math.abs(percentage) / 2.5, 1);
  return percentage > 0
    ? `rgba(76, 175, 80, ${intensity})`
    : `rgba(244, 67, 54, ${intensity})`;
};

const getTextColor = (percentage) => {
  return Math.abs(percentage) > 0.5 ? '#fff' : '#000';
};

const ProductList = ({ title, products, isGainer }) => (
  <div className="product-list">
    <h3>{title}</h3>
    <ul>
      {products.map((product, index) => {
        const change = (isGainer ? Math.random() * 2 + 0.5 : -(Math.random() * 2 + 0.5)).toFixed(2);
        return (
          <li key={index} className="product-card" style={{ backgroundColor: getBackgroundColor(change), color: getTextColor(change) }}>
            <div className="product-info">
              <span className="product-name">{product}</span>
              <span className={`product-change ${isGainer ? 'positive' : 'negative'}`}>
                <FontAwesomeIcon icon={isGainer ? faArrowUp : faArrowDown} color={isGainer ? "#4caf50" : "#f44336"} /> {change}%
              </span>
            </div>
            <div className="product-details">
              <div><FontAwesomeIcon icon={faChartLine} color="#2196f3" /> NAV: ₹{(Math.random() * 100).toFixed(2)}</div>
              <div><FontAwesomeIcon icon={faPercentage} color="#ff9800" /> Expense Ratio: {(Math.random() * 2).toFixed(2)}%</div>
              <div><FontAwesomeIcon icon={faShieldAlt} color="#9c27b0" /> Risk Level: {isGainer ? 'Moderate' : 'High'}</div>
              <div><FontAwesomeIcon icon={faCalendarAlt} color="#3f51b5" /> Launch Date: {new Date(+(new Date()) - Math.floor(Math.random() * 1000000000000)).toLocaleDateString()}</div>
              <div><FontAwesomeIcon icon={faPiggyBank} color="#009688" /> Total AUM: ₹{(Math.random() * 1000).toFixed(2)} Cr</div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const TopGainers = () => (
  <div className="top-gainers">
    <h3>Top 5 Gainer Products</h3>
    <ul>
      {['BANK OF INDIA Large & Mid Cap Equity Fund Eco Plan- Growth', 'SBI Bluechip Fund', 'ICICI Prudential Value Discovery Fund', 'Axis Long Term Equity Fund', 'Kotak Standard Multicap Fund'].map((product, index) => {
        const change = (Math.random() * 2 + 0.5).toFixed(2); // Random percentage between 0.5% and 2.5%
        return (
          <li key={index} className="product-card" style={{ backgroundColor: getBackgroundColor(change), color: getTextColor(change) }}>
            <div className="product-info">
              <span className="product-name">{product}</span>
              <span className="product-change positive">
                <FontAwesomeIcon icon={faArrowUp} color="#4caf50" /> {change}%
              </span>
            </div>
            <div className="product-details">
              <div><FontAwesomeIcon icon={faChartLine} color="#2196f3" /> NAV: ₹{Math.random().toFixed(2)}</div>
              <div><FontAwesomeIcon icon={faPercentage} color="#ff9800" /> Expense Ratio: {Math.random().toFixed(2)}%</div>
              <div><FontAwesomeIcon icon={faShieldAlt} color="#9c27b0" /> Risk Level: Moderate</div>
              <div><FontAwesomeIcon icon={faCalendarAlt} color="#3f51b5" /> Launch Date: {new Date(+(new Date()) - Math.floor(Math.random() * 1000000000000)).toLocaleDateString()}</div>
              <div><FontAwesomeIcon icon={faPiggyBank} color="#009688" /> Total AUM: ₹{(Math.random() * 1000).toFixed(2)} Cr</div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const TopLosers = () => (
  <div className="top-losers">
    <h3>Top 5 Loser Products</h3>
    <ul>
      {['Reliance Small Cap Fund', 'DSP BlackRock Micro Cap Fund', 'Franklin India Smaller Companies Fund', 'L&T Emerging Businesses Fund', 'Mirae Asset Emerging Bluechip Fund'].map((product, index) => {
        const change = -(Math.random() * 2 + 0.5).toFixed(2); // Random percentage between -0.5% and -2.5%
        return (
          <li key={index} className="product-card" style={{ backgroundColor: getBackgroundColor(change), color: getTextColor(change) }}>
            <div className="product-info">
              <span className="product-name">{product}</span>
              <span className="product-change negative">
                <FontAwesomeIcon icon={faArrowDown} color="#f44336" /> {change}%
              </span>
            </div>
            <div className="product-details">
              <div><FontAwesomeIcon icon={faChartLine} color="#2196f3" /> NAV: ₹{(Math.random() * 100).toFixed(2)}</div>
              <div><FontAwesomeIcon icon={faPercentage} color="#ff9800" /> Expense Ratio: {(Math.random() * 2).toFixed(2)}%</div>
              <div><FontAwesomeIcon icon={faShieldAlt} color="#9c27b0" /> Risk Level: High</div>
              <div><FontAwesomeIcon icon={faCalendarAlt} color="#3f51b5" /> Launch Date: {new Date(+(new Date()) - Math.floor(Math.random() * 1000000000000)).toLocaleDateString()}</div>
              <div><FontAwesomeIcon icon={faPiggyBank} color="#009688" /> Total AUM: ₹{(Math.random() * 1000).toFixed(2)} Cr</div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const TopCategories = () => (
  <div className="top-categories">
    <h3>Top 5 Categories</h3>
    <ul>
      {['Small Cap', 'Mid Cap', 'Large Cap', 'Thematic', 'Equity'].map((category, index) => {
        const change = (Math.random() * 2 + 0.5).toFixed(2); // Random percentage between 0.5% and 2.5%
        return (
          <li key={index} className="category-card" style={{ backgroundColor: getBackgroundColor(change), color: getTextColor(change) }}>
            <div className="category-info">
              <span className="category-name">{category}</span>
              <span className="category-change positive">
                <FontAwesomeIcon icon={faArrowUp} color="#4caf50" /> {change}%
              </span>
            </div>
            <div className="category-details">
              <div><FontAwesomeIcon icon={faPiggyBank} color="#2196f3" /> Total AUM: ₹{(Math.random() * 100).toFixed(2)}B</div>
              <div><FontAwesomeIcon icon={faPercentage} color="#ff9800" /> Avg. Expense Ratio: {(Math.random() * 2).toFixed(2)}%</div>
              <div><FontAwesomeIcon icon={faShieldAlt} color="#9c27b0" /> Risk Level: Low</div>
              <div><FontAwesomeIcon icon={faBuilding} color="#ff9800" /> Number of AMCs: {Math.floor(Math.random() * 10) + 1}</div>
              <div><FontAwesomeIcon icon={faBoxes} color="#9c27b0" /> Number of Products: {Math.floor(Math.random() * 50) + 1}</div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const TopLoserCategories = () => (
  <div className="top-loser-categories">
    <h3>Top 5 Loser Categories</h3>
    <ul>
      {['Debt', 'Smallcase', 'Balanced', 'Multi Cap', 'Sectoral'].map((category, index) => {
        const change = -(Math.random() * 2 + 0.5).toFixed(2); // Random percentage between -0.5% and -2.5%
        return (
          <li key={index} className="category-card" style={{ backgroundColor: getBackgroundColor(change), color: getTextColor(change) }}>
            <div className="category-info">
              <span className="category-name">{category}</span>
              <span className="category-change negative">
                <FontAwesomeIcon icon={faArrowDown} color="#f44336" /> {change}%
              </span>
            </div>
            <div className="category-details">
              <div><FontAwesomeIcon icon={faPiggyBank} color="#2196f3" /> Total AUM: ₹{(Math.random() * 100).toFixed(2)}B</div>
              <div><FontAwesomeIcon icon={faPercentage} color="#ff9800" /> Avg. Expense Ratio: {(Math.random() * 2).toFixed(2)}%</div>
              <div><FontAwesomeIcon icon={faShieldAlt} color="#9c27b0" /> Risk Level: High</div>
              <div><FontAwesomeIcon icon={faBuilding} color="#ff9800" /> Number of AMCs: {Math.floor(Math.random() * 10) + 1}</div>
              <div><FontAwesomeIcon icon={faBoxes} color="#9c27b0" /> Number of Products: {Math.floor(Math.random() * 50) + 1}</div>
            </div>
          </li>
        );
      })}
    </ul>
  </div>
);

const CombinedCardTopGainers = ({ data, loading, title, renderNoDataMessage, config }) => (
  <div className="combined-card-top-gainers">
    <div className="combined-card">
      <h3>{title}</h3>
      {loading ? (
        <p>Loading...</p>
      ) : data.length ? (
        data.map((product, index) => (
          <div key={index} className="product-info">
            <a 
              href={`${config.siteUrl}/product-detail/${product.product_code}`}
              className="product-link"
            >
              <span className="product-name">{product.name}</span>
              <span className="product-change positive">
                <FontAwesomeIcon icon={faArrowUp} color="#4caf50" /> 
                {product.returns_3yr?.toFixed(2)}%
              </span>
            </a>
          </div>
        ))
      ) : (
        renderNoDataMessage('No top gainer products available.')
      )}
    </div>
  </div>
);

const CombinedCardTopLosers = ({ data, loading, title, renderNoDataMessage, config }) => (
  <div className="combined-card-top-losers">
    <div className="combined-card">
      <h3>{title}</h3>
      {loading ? (
        <p>Loading...</p>
      ) : (
        data.map((product, index) => (
          <div key={index} className="product-info">
            <a 
              href={`${config.siteUrl}/product-detail/${product.product_code}`}
              className="product-link"
            >
              <span className="product-name">{product.name}</span>
              <span className="product-change negative">
                <FontAwesomeIcon icon={faArrowDown} color="#f44336" /> 
              {product.returns_3yr?.toFixed(2)}%
              </span>
            </a>
          </div> 
        ))
      )}
      {renderNoDataMessage && !data.length && !loading && renderNoDataMessage('No top loser products available.')}
    </div>
  </div>
);

const CombinedCardTopCategories = ({ data, loading, title, renderNoDataMessage, config }) => (
  <div className="combined-card-top-categories">
    <div className="combined-card">
      <h3>{title}</h3>
      {loading ? (
        <p>Loading...</p>
      ) : data.length ? (
        data.map((category, index) => (
          <div key={index} className="category-info">
            {category.custom_url ? (
              <a 
                href={`${category.custom_url}`}
                className="category-link"
              >
                <span className="category-name">{category.name}</span>
                <span className="category-change positive">
                  <FontAwesomeIcon icon={faArrowUp} color="#4caf50" /> 
                  {category.returns_3yr?.toFixed(2)}%
                </span>
              </a>
            ) : (
              <a 
                href={`${config.siteUrl}/category/${category.category_code}`}
                className="category-link"
              >
                <span className="category-name">{category.name}</span>
                <span className="category-change positive">
                  <FontAwesomeIcon icon={faArrowUp} color="#4caf50" /> 
                  {category.returns_3yr?.toFixed(2)}%
                </span>
              </a>
            )}
          </div>
        ))
      ) : (
        renderNoDataMessage('No top gainer categories available.')
      )}
    </div>
  </div>
);

const CombinedCardTopLoserCategories = ({ data, loading, title, renderNoDataMessage, config }) => (
  <div className="combined-card-top-loser-categories">
    <div className="combined-card">
      <h3>{title}</h3>
      {loading ? (
        <p>Loading...</p>
      ) : (
        data.map((category, index) => (
          <div key={index} className="category-info">
            {category.custom_url ? (
              <a 
                href={`${category.custom_url}`}
                className="category-link"
              >
                <span className="category-name">{category.name}</span>
                <span className="category-change negative">
                  <FontAwesomeIcon icon={faArrowDown} color="#f44336" /> 
                  {category.returns_3yr?.toFixed(2)}%
                </span>
              </a>
            ) : (
              <a 
                href={`${config.siteUrl}/category/${category.category_code}`}
                className="category-link"
              >
                <span className="category-name">{category.name}</span>
                <span className="category-change negative">
                  <FontAwesomeIcon icon={faArrowDown} color="#f44336" /> 
                  {category.returns_3yr?.toFixed(2)}%
                </span>
              </a>
            )}
          </div>
        ))
      )}
      {renderNoDataMessage && !data.length && !loading && renderNoDataMessage('No top loser categories available.')}
    </div>
  </div>
);

const iconMap = {
  faUmbrella,
  faHeartbeat,
  faCoins,
  faCar,
  faMotorcycle,
  faUsers,
  faPlane,
  faFemale,
  faPiggyBank,
  faChild,
  faUserShield,
  faHome,
  faChartLine,
  faBalanceScale,
  faChartPie,
  faChartBar,
  faChartArea,
};

const CategorySnapshot = ({ config }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchWithRetry(`${config.PY_API_URL}/api/home-page-categories`)
      .then(data => {
        if (data.status === 'success') {
          const groupedCategories = data.data.reduce((acc, category) => {
            if (!acc[category.row]) {
              acc[category.row] = [];
            }
            acc[category.row].push(category);
            return acc;
          }, {});
          setCategories(groupedCategories);
        }
      })
      .catch(error => console.error('Error fetching categories:', error));
  }, []);

  return (
    <div className="home-category-snapshot">
      {Object.keys(categories).map(row => (
        <div key={row} className="home-category-row">
          {categories[row].map((category, index) => (
            <a
              key={index}
              className="home-category-item"
              style={{ backgroundColor: category.bg_color }}
              href={category.custom_url || `${config.siteUrl}/category/${category.category_code}`}
            >
              {category.badge && <div className="home-category-badge">{category.badge}</div>}
              <div className="home-category-icon">
                <FontAwesomeIcon icon={iconMap[category.icon]} size="2x" color="#fff" />
              </div>
              <div className="home-category-label">{category.name}</div>
            </a>
          ))}
        </div>
      ))}
    </div>
  );
};

const MarketStatus = ({ config, marketStatus }) => {
  return (
    <div className="market-status" style={{marginBottom: '0px'}}>
      <h3 style={{fontSize: '16px', fontWeight: 'bold', float: 'left', marginRight: '10px'}}>Market Status: </h3>
      <div className="market-status-content" style={{float: 'left', marginTop: '-6px', fontSize: '16px'}}>
        <div className="market-status-item">
          <div className="market-status-item-icon">
            <FontAwesomeIcon icon={faClock} style={{marginRight: '10px', fontSize: '16px', color: marketStatus.marketState?.[0]?.marketStatus.toLowerCase() === 'open' ? '#4caf50' : '#f44336'}} />
            {marketStatus.marketState?.[0]?.marketStatus.toLowerCase() === 'open' ?
              <span className="market-status-item-value" style={{color: '#4caf50'}}>Open</span> 
              : 
              <span className="market-status-item-value" style={{color: '#f44336'}}>Closed</span>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

const IndicativeNifty50 = ({ config, marketStatus }) => {
  return (
    <div className="indicative-nifty50" style={{marginBottom: '0px'}}>
      <h3 style={{ fontSize: "16px", fontWeight: "bold", float: 'left', marginRight: '10px'}}>Nifty 50:</h3>
      <div className="indicative-nifty50-content" style={{float: 'left', marginTop: '-6px', fontSize: '16px'}}>
        <div className="indicative-nifty50-item">
          <div className="indicative-nifty50-item-icon">
            <FontAwesomeIcon icon={faChartArea} style={{marginRight: "10px", fontSize: "16px", color: marketStatus.indicativenifty50?.change > 0 ? '#4caf50' : '#f44336'}} />
            <span className="indicative-nifty50-item-value" style={{ marginRight: "10px" }}>
              {marketStatus.indicativenifty50?.closingValue}
            </span>
            {marketStatus.indicativenifty50?.change > 0 ? (
              <span className="indicative-nifty50-item-value positive" style={{ marginRight: "10px", color: "#4caf50" }}>
                {marketStatus.indicativenifty50?.change.toFixed(2)}
              </span>
            ) : (
              <span className="indicative-nifty50-item-value negative" style={{ marginRight: "10px", color: "#f44336" }}>
                {marketStatus.indicativenifty50?.change.toFixed(2)}
              </span>
            )}
            ({marketStatus.indicativenifty50?.perChange > 0 ? (
              <span className="indicative-nifty50-item-value positive" style={{ color: "#4caf50" }}>
                {marketStatus.indicativenifty50?.perChange.toFixed(2)}%
              </span>
            ) : (
              <span className="indicative-nifty50-item-value negative" style={{ color: "#f44336" }}>
                {marketStatus.indicativenifty50?.perChange.toFixed(2)}%
              </span>
            )})
          </div>
        </div>
      </div>
    </div>
  );
};


const GiftNifty = ({ config, marketStatus }) => {
  return (
    <div className="gift-nifty" style={{marginBottom: '0px'}}>
      <h3 style={{fontSize: '16px', fontWeight: 'bold', float: 'left', marginRight: '10px'}}>Gift Nifty: </h3>
      <div className="gift-nifty-content" style={{float: 'left', marginTop: '-6px', fontSize: '16px'}}>
        <div className="gift-nifty-item">
          <div className="gift-nifty-item-icon">
            <FontAwesomeIcon icon={faChartLine} style={{marginRight: '10px', fontSize: '16px', color: marketStatus.giftnifty?.DAYCHANGE > 0 ? '#4caf50' : '#f44336'}} />
            <span className="gift-nifty-item-value" style={{marginRight: '10px'}}>{marketStatus.giftnifty?.LASTPRICE}</span>
            {marketStatus.giftnifty?.DAYCHANGE > 0 ? (
              <span className="gift-nifty-item-value positive" style={{marginRight: '10px', color: '#4caf50'}}>{marketStatus.giftnifty?.DAYCHANGE}</span>
            ) : (
              <span className="gift-nifty-item-value negative" style={{marginRight: '10px', color: '#f44336'}}>{marketStatus.giftnifty?.DAYCHANGE}</span>
            )}
            ({marketStatus.giftnifty?.PERCHANGE > 0 ? (
              <span className="gift-nifty-item-value positive" style={{color: '#4caf50'}}>{marketStatus.giftnifty?.PERCHANGE}%</span>
            ) : (
              <span className="gift-nifty-item-value negative" style={{color: '#f44336'}}>{marketStatus.giftnifty?.PERCHANGE}%</span>
            )})
          </div>
        </div>
      </div>
    </div>  
  );
};

const USDINR = ({ config, marketStatus }) => {
  return (
    <div className="usd-inr" style={{marginBottom: '0px'}}>
      <h3 style={{fontSize: '16px', fontWeight: 'bold', float: 'left', marginRight: '10px'}}>1 <FontAwesomeIcon icon={faDollarSign} style={{fontSize: '16px'}} /> = 
        <span className="usd-inr-item-value" style={{marginRight: '10px', marginLeft: '5px'}}>{marketStatus.usdinr?.last} <FontAwesomeIcon icon={faIndianRupee} style={{fontSize: '16px'}} /></span>
      </h3>
    </div>
  );
};

class MMCategoryBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryData: {},
      categorySummary: {},
      childCategories: [],
      parentCategories: [],
      loading: true,
      error: null,
      blockData: {},
      topPerformers: { gainers: [], losers: [] },
      topCategories: { gainers: [], losers: [] },
      loadingPerformers: false,
      loadingCategories: false,
      returnPeriod: '3',
      marketStatus: {},
      loadingMarketStatus: false,
    };
  }

  componentDidMount() {
    this.fetchCategoryData();
    if (this.props.config.showTopGainers || this.props.config.showTopLosers) {
      this.fetchTopPerformers();
    }
    if (this.props.config.showTopCategories || this.props.config.showTopLoserCategories) {
      this.fetchTopCategories();
    }
    // to test set value in config to true
    // if (window.location.href.includes('localhost')) {
    //   this.props.config.showMarketStatus = true;
    //   this.props.config.indicativenifty50 = true;
    //   this.props.config.giftnifty = true;
    //   this.props.config.usdinr = true;
    // }
    if (this.props.config.showMarketStatus || this.props.config.indicativenifty50 || this.props.config.giftnifty || this.props.config.usdinr) {
      this.fetchMarketStatus();
    }
  }

  fetchCategoryData() {
    const { config } = this.props;
    const apiUrl = `${config.PY_API_URL}category/${encodeURIComponent(config.categoryCode)}/children`;

    fetchWithRetry(apiUrl)
      .then(categoryResponse => {
        const { category, child_category: childCategories, parent_categories: parentCategories, category_summary: categorySummary } = categoryResponse.data;
        this.setState({
          categoryData: category,
          childCategories,
          parentCategories,
          blockData: category.block_data,
          loading: false,
          categorySummary: categorySummary
        });
        
        // Update document metadata
        document.title = `Money Marche - ${category.title}`;
        this.updateMetaTags(category);
      })
      .catch(error => {
        console.error('Error fetching category and block data:', error);
        this.setState({ loading: false, error: 'Error fetching data' });
      });
  }

  updateMetaTags(category) {
    const metaTags = {
      description: document.querySelector('meta[name="description"]'),
      title: document.querySelector('meta[name="title"]'),
      keywords: document.querySelector('meta[name="keywords"]')
    };

    if (metaTags.description) {
      metaTags.description.setAttribute('content', category.meta_description);
    }
    if (metaTags.title) {
      metaTags.title.setAttribute('content', category.meta_title);
    }
    if (metaTags.keywords) {
      metaTags.keywords.setAttribute('content', category.meta_keywords);
    }
  }

  fetchTopPerformers = async () => {
    const { config } = this.props;
    if (!config.showTopGainers && !config.showTopLosers) return;
    
    this.setState({ loadingPerformers: true });
    try {
      const data = await fetchWithRetry(
        `${config.PY_API_URL}market/top-product-performers?return_period=${this.state.returnPeriod}`
      );
      
      if (data.status === 'success') {
        this.setState({
          topPerformers: {
            gainers: data.data.top_gainers,
            losers: data.data.top_losers,
          },
        });
      }
    } catch (error) {
      console.error('Error fetching top performers:', error);
    } finally {
      this.setState({ loadingPerformers: false });
    }
  };

  fetchTopCategories = async () => {
    const { config } = this.props;
    if (!config.showTopCategories && !config.showTopLoserCategories) return;
    
    this.setState({ loadingCategories: true });
    try {
      const data = await fetchWithRetry(
        `${config.PY_API_URL}market/top-category-performers?return_period=${this.state.returnPeriod}`
      );
      
      if (data.status === 'success') {
        this.setState({
          topCategories: {
            gainers: data.data.top_gainers,
            losers: data.data.top_losers,
          },
        });
      }
    } catch (error) {
      console.error('Error fetching top categories:', error);
    } finally {
      this.setState({ loadingCategories: false });
    }
  };

  fetchMarketStatus = async () => {
    const { config } = this.props;
    if (!config.showMarketStatus && !config.indicativenifty50 && !config.giftnifty && !config.usdinr) return;
    
    this.setState({ loadingMarketStatus: true });
    try {
      const data = await fetchWithRetry(`${config.PY_API_URL}market/status`);
      
      if (data?.market_status) {
        let responseData = data.market_status;
        responseData.usdinr = responseData.marketState.find(item => item?.underlying === 'USDINR') || {};

        this.setState({ marketStatus: responseData });
        
        // Set up polling if market is open
        if (responseData.marketState?.[0]?.marketStatus.toLowerCase() === 'open') {
          setTimeout(() => this.fetchMarketStatus(), 10000); // Poll every 10 seconds
        }
      }
    } catch (error) {
      console.error('Error fetching market status:', error);
    } finally {
      this.setState({ loadingMarketStatus: false });
    }
  };

  renderNoDataMessage(message) {
    return (
      <div className="no-data-message" style={{margin: '10px'}}>
        <FontAwesomeIcon icon={faInfoCircle} /> {message}
      </div>
    );
  }

  render() {
    const { categoryData, childCategories, parentCategories, loading, error, blockData, categorySummary, topPerformers, loadingPerformers, topCategories, loadingCategories, returnPeriod } = this.state;
    const { config } = this.props;

    
    let hasInvestmentCategory = parentCategories.some(
        (parent) => (parent.category_code === "investments" || parent.category_code === "mutual-funds")
    );

    if (!hasInvestmentCategory) {
      if (categoryData.category_code === "investments" || categoryData.category_code === "mutual-funds") {
        hasInvestmentCategory = true;
      }
    }
    if (loading) {
      return <p>Loading...</p>;
    }

    if (error) {
      return <p>{error}</p>;
    }

    const enquiryFormConfig = {
      ...config,
      renderInline: true,
      showCategoryForm: true,
      productCode: categoryData?.scheme_code,
      categoryCode: categoryData?.category_code,
    };

    const enquiryFormConfigInline = {
      ...enquiryFormConfig, // Use the existing config as a base
      renderInline: false, // Set to true for inline rendering
      showCategoryForm: true, // Ensure the category form is shown
      buttonText: "Start Your Journey Now", // Custom button text
      buttonClass: "full-width-button", // Custom CSS class for full width
      buttonStyle: JSON.stringify({
          width: '250px',
          textAlign: 'center',
          backgroundColor: '#6200ea',
          color: '#fff',
          borderRadius: '5px',
          cursor: 'pointer',
      }),
    };

    const inlineEnquiryForm = {
      ...enquiryFormConfigInline,
      renderInline: true,
      hideHeaderSection: true,
      categoryCode: 'contact-form-category-page'
    }

    return (
      <div className="category-main">
        {config.showNFOList && (
          <NFOList config={config} />
        )}
        {config.show_calculator_list && (
          <CalculatorList config={config} />
        )}
        {config.showIndexChart && (
          <IndexChart config={config} style={{width: '100%', marginBottom: '120px'}} />
        )}
        {(config.showMarketStatus || config.indicativenifty50 || config.giftnifty || config.usdinr) && (
          <div className="market-status-container card" style={{marginBottom: '0px', paddingBottom: '0px'}}>
            {config.showMarketStatus && (
              <MarketStatus config={config} marketStatus={this.state.marketStatus} />
            )}
            {config.indicativenifty50 && (
              <IndicativeNifty50 config={config} marketStatus={this.state.marketStatus} />
            )}
            {config.giftnifty && (
              <GiftNifty config={config} marketStatus={this.state.marketStatus} />
            )}
            {config.usdinr && (
              <USDINR config={config} marketStatus={this.state.marketStatus} />
            )}
          </div>
        )}


        {/* {config.showMarketStatus && (
          <MarketStatus config={config} marketStatus={this.state.marketStatus} />
        )}
        {config.indicativenifty50 && (
          <IndicativeNifty50 config={config} marketStatus={this.state.marketStatus} />
        )}
        {config.giftnifty && (
          <GiftNifty config={config} marketStatus={this.state.marketStatus} />
        )}
        {config.usdinr && (
          <USDINR config={config} marketStatus={this.state.marketStatus} />
        )}         */}
        {config.showCategorySnapshot && (
          <div>
            <CategorySnapshot config={config}/>
          </div>
        )}
        {/* <div className="return-period-selector">
          <label>Select Return Period: </label>
          <select value={returnPeriod} onChange={(e) => this.setState({ returnPeriod: e.target.value })}>
            <option value="1">1 Year</option>
            <option value="3">3 Years</option>
            <option value="5">5 Years</option>
          </select>
        </div> */}

        <div className="combined-card-top-performers" style={{width: '100%', clear: 'both'}}>
          {config.showTopGainers && (
            <CombinedCardTopGainers 
              data={topPerformers.gainers}
              loading={loadingPerformers}
              title={`Top Gainer Products (${returnPeriod}Y)`}
              renderNoDataMessage={this.renderNoDataMessage}
              config={config}
            />
          )}
          {config.showTopLosers && (
            <CombinedCardTopLosers 
              data={topPerformers.losers}
              loading={loadingPerformers}
              title={`Top Loser Products (${returnPeriod}Y)`}
              renderNoDataMessage={this.renderNoDataMessage}
              config={config}
            />
          )}

          {config.showTopCategories && (
            <CombinedCardTopCategories 
              data={topCategories.gainers}
              loading={loadingCategories}
              title={`Top Gainer Categories (${returnPeriod}Y)`}
              renderNoDataMessage={this.renderNoDataMessage}
              config={config}
            />
          )}
          {config.showTopLoserCategories && (
            <CombinedCardTopLoserCategories 
              data={topCategories.losers}
              loading={loadingCategories}
              title={`Top Loser Categories (${returnPeriod}Y)`}
              renderNoDataMessage={this.renderNoDataMessage}
              config={config}
            />
          )}

        </div>
        {/* <TopGainers />
        <TopLosers />
        <TopCategories />
        <TopLoserCategories /> */}

        {config.showHeaderSection && (
        <div className="hero-section" style={{width: '100%', clear:"both"}}>
          <div className="hero-content">
            {config.showBreadcrumb && (
              <div className="hero-breadcrumb">
                <CustomCategoryBreadcrumb 
                  categories={parentCategories} 
                  currentCategory={categoryData} 
                  config={config} 
                />
              </div>
            )}
            <h1 className="hero-title">{categoryData.title || ''}</h1>
            <p className="hero-description">
              <span dangerouslySetInnerHTML={{ __html: categoryData.short_description || '' }} />
            </p>
            {/* <a href="#" className="hero-cta">Start Your Journey Now</a> */}
            <EnquiryForm config={enquiryFormConfigInline} />
          </div>

          {hasInvestmentCategory && hasInvestmentCategory ? (
            <>
              <div className="hero-content elementor-widget-container widget-wrapper" style={{marginTop:'0px', fontSize: '16px', paddingBottom: '20px'}}>
                <EnquiryForm config={inlineEnquiryForm} />
              </div>
              {/* <div className="hero-stats">
                <div className="stats-grid">
                  <div className="stat-item highlight">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faChartPie} />
                    </div>
                    <div className="stat-label">Total Funds</div>
                    <div className="stat-value">{categorySummary?.total_funds || "N/A"}</div>
                  </div>
                  
                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faBuilding} />
                    </div>
                    <div className="stat-label">Total AMC's</div>
                    <div className="stat-value">{categorySummary?.amc_count || "N/A"}</div>
                  </div>
                  
                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faWallet} />
                    </div>
                    <div className="stat-label">Total AUM</div>
                    <div className="stat-value">{categorySummary?.total_aum || "N/A"}</div>
                  </div>
                  
                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                    </div>
                    <div className="stat-label">Latest Launch</div>
                    <div className="stat-value">{formatDate(categorySummary?.latest_launch_date) || "N/A"}</div>
                  </div>

                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faChartLine} />
                    </div>
                    <div className="stat-label">1Y Returns</div>
                    <div className={`stat-value ${categorySummary?.returns_1yr > 0 ? 'positive' : 'negative'}`}>
                      {categorySummary?.returns_1yr?.toFixed(2) || "N/A"}%
                      {categorySummary?.returns_1yr > 0 ? 
                        <span className="stat-trend up">↑</span> : 
                        <span className="stat-trend down">↓</span>
                      }
                    </div>
                  </div>

                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faChartArea} />
                    </div>
                    <div className="stat-label">3Y Returns</div>
                    <div className={`stat-value ${categorySummary?.returns_3yr > 0 ? 'positive' : 'negative'}`}>
                      {categorySummary?.returns_3yr?.toFixed(2) || "N/A"}%
                      {categorySummary?.returns_3yr > 0 ? 
                        <span className="stat-trend up">↑</span> : 
                        <span className="stat-trend down">↓</span>
                      }
                    </div>
                  </div>

                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faChartBar} />
                    </div>
                    <div className="stat-label">5Y Returns</div>
                    <div className={`stat-value ${categorySummary?.returns_5yr > 0 ? 'positive' : 'negative'}`}>
                      {categorySummary?.returns_5yr?.toFixed(2) || "N/A"}%
                      {categorySummary?.returns_5yr > 0 ? 
                        <span className="stat-trend up">↑</span> : 
                        <span className="stat-trend down">↓</span>
                      }
                    </div>
                  </div>

                  <div className="stat-item">
                    <div className="stat-icon">
                      <FontAwesomeIcon icon={faArrowsAltV} />
                    </div>
                    <div className="stat-label">3Y Range</div>
                    <div className="stat-value range">
                      <span className="negative">{categorySummary?.min_returns_3yr?.toFixed(2) || "N/A"}%</span>
                      <span className="separator">to</span>
                      <span className="positive">{categorySummary?.max_returns_3yr?.toFixed(2) || "N/A"}%</span>
                    </div>
                  </div>
                </div>
              </div> */}
            </>
          ) : (
            <div className="hero-stats">
              <div className="stats-grid">
                <div className="stat-item highlight">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faChartPie} /> Total Products
                  </div>
                  {/* <div className="stat-label">Total Products</div> */}
                  <div className="stat-value">{categorySummary?.total_funds || "N/A"}</div>
                </div>
                
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faBuilding} /> Total AMC's
                  </div>
                  {/* <div className="stat-label">Total AMC's</div> */}
                  <div className="stat-value">{categorySummary?.amc_count || "N/A"}</div>
                </div>
                
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCalendarAlt} /> Latest Launch
                  </div>
                  {/* <div className="stat-label">Latest Launch</div> */}
                  <div className="stat-value">{formatDate(categorySummary?.latest_launch_date) || "N/A"}</div>
                </div>
              </div>
            </div>
          )}
        </div>
        )}
        
        {((config.showCategoryStatsBlock1) && hasInvestmentCategory ? (
            <div className="hero-stats">
              <div className="stats-grid">
                <div className="stat-item highlight">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faChartPie} /> Total Funds
                  </div>
                  {/* <div className="stat-label">Total Funds</div> */}
                  <div className="stat-value">{categorySummary?.total_funds || "N/A"}</div>
                </div>
                
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faBuilding} /> Total AMC's
                  </div>
                  {/* <div className="stat-label">Total AMC's</div> */}
                  <div className="stat-value">{categorySummary?.amc_count || "N/A"}</div>
                </div>
                
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faWallet} /> Total AUM
                  </div>
                  {/* <div className="stat-label">Total AUM</div> */}
                  <div className="stat-value">{categorySummary?.total_aum || "N/A"}</div>
                </div>
              </div>
            </div>
        ) : (
          <></>
        ))}
        {((config.showCategoryStatsBlock2) && hasInvestmentCategory ? (
          <div className="hero-stats">
            <div className="stats-grid">
              <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCalendarAlt} /> Start Date
                  </div>
                  {/* <div className="stat-label">Start Date</div> */}
                  <div className="stat-value">{formatDate(categorySummary?.start_data) || "N/A"}</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faCalendarAlt} /> Latest Launch
                  </div>
                  {/* <div className="stat-label">Latest Launch</div> */}
                  <div className="stat-value">{formatDate(categorySummary?.latest_launch_date) || "N/A"}</div>
                </div>
                

                <div className="stat-item highlight">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faArrowsAltV} /> 3Y Range
                  </div>
                  {/* <div className="stat-label">3Y Range</div> */}
                  <div className="stat-value range">
                    <span className="negative">{categorySummary?.min_returns_3yr?.toFixed(2) || "N/A"}%</span>
                    <span className="separator">to</span>
                    <span className="positive">{categorySummary?.max_returns_3yr?.toFixed(2) || "N/A"}%</span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <></>
        ))}
        {((config.showCategoryStatsBlock3) && hasInvestmentCategory ? (
          <div className="hero-stats">
            <div className="stats-grid">
                
                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faChartLine} /> 1Y Returns
                  </div>
                  {/* <div className="stat-label">1Y Returns</div> */}
                  <div className={`stat-value ${categorySummary?.returns_1yr > 0 ? 'positive' : 'negative'}`}>
                    {categorySummary?.returns_1yr?.toFixed(2) || "N/A"}%
                    {categorySummary?.returns_1yr > 0 ? 
                      <span className="stat-trend up">↑</span> : 
                      <span className="stat-trend down">↓</span>
                    }
                  </div>
                </div>

                <div className="stat-item highlight">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faChartArea} /> 3Y Returns
                  </div>
                  {/* <div className="stat-label">3Y Returns</div> */}
                  <div className={`stat-value ${categorySummary?.returns_3yr > 0 ? 'positive' : 'negative'}`}>
                    {categorySummary?.returns_3yr?.toFixed(2) || "N/A"}%
                    {categorySummary?.returns_3yr > 0 ? 
                      <span className="stat-trend up">↑</span> : 
                      <span className="stat-trend down">↓</span>
                    }
                  </div>
                </div>

                <div className="stat-item">
                  <div className="stat-icon">
                    <FontAwesomeIcon icon={faChartBar} /> 5Y Returns
                  </div>
                  {/* <div className="stat-label">5Y Returns</div> */}
                  <div className={`stat-value ${categorySummary?.returns_5yr > 0 ? 'positive' : 'negative'}`}>
                    {categorySummary?.returns_5yr?.toFixed(2) || "N/A"}%
                    {categorySummary?.returns_5yr > 0 ? 
                      <span className="stat-trend up">↑</span> : 
                      <span className="stat-trend down">↓</span>
                    }
                  </div>
                </div>

                </div>
              </div>
        ) : (
          <></>
        ))}

        {config.sectionsOrder?.map((sectionKey) => {
          switch(sectionKey) {
            case 'childCategories':
              return config.showChildCategories && childCategories.length > 0 && (
                <>
                <div key="childCategories" className="equity-funds-section">
                  <div className="equity-header">
                    <h2>Types of {categoryData.name || 'Funds'}</h2>
                  </div>
                  
                  <div style={{overflow: 'scroll'}} className={`equity-funds-grid ${childCategories.length > 4 ? 'scrollable' : ''}`}>
                    {childCategories.map((category, index) => (
                      <>
                        
                      <div 
                        className="equity-fund-card"
                        style={{
                          width: childCategories.length <= 4 ? 
                            (childCategories.length === 3 ? 'calc(33.33% - 20px)' : 
                             childCategories.length === 2 ? 'calc(50% - 15px)' : 'calc(25% - 23px)') : '300px'
                        }}
                        key={index}
                      >
                        <div className="fund-icon">
                          <i className={`flaticonv3 ${category.icon_code || "flaticonv3-save-money"}`}></i>
                        </div>
                        <h3>{category.title}</h3>
                        <div className="fund-description">
                          <p dangerouslySetInnerHTML={{ __html: category.category_short_description || 'Description not available' }} />
                        </div>
                        <div className="item--button">
                          {category.custom_url && 
                            <a className="btn-arrow2" href={`${category.custom_url}`}>
                              <span>Read More</span>
                              <i className="flaticonv2-right-arrow"></i>
                            </a>
                          }
                          {!category.custom_url && 
                            <a className="btn-arrow2" href={`${config.siteUrl}/category/${category.category_code}`}>
                              <span>Read More</span>
                              <i className="flaticonv2-right-arrow"></i>
                            </a>
                          }
                        </div>
                      </div>
                      </>
                      
                    ))}
                  </div>
                </div>
                {((config.showCategoryStats) && hasInvestmentCategory ? (
                  <div className="hero-stats">
                    <div className="stats-grid">
                      <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faCalendarAlt} /> Start Date
                          </div>
                          {/* <div className="stat-label">Start Date</div> */}
                          <div className="stat-value">{formatDate(categorySummary?.start_data) || "N/A"}</div>
                        </div>
                        <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faCalendarAlt} /> Latest Launch
                          </div>
                          {/* <div className="stat-label">Latest Launch</div> */}
                          <div className="stat-value">{formatDate(categorySummary?.latest_launch_date) || "N/A"}</div>
                        </div>
                        

                        <div className="stat-item highlight">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faArrowsAltV} /> 3Y Range
                          </div>
                          {/* <div className="stat-label">3Y Range</div> */}
                          <div className="stat-value range">
                            <span className="negative">{categorySummary?.min_returns_3yr?.toFixed(2) || "N/A"}%</span>
                            <span className="separator">to</span>
                            <span className="positive">{categorySummary?.max_returns_3yr?.toFixed(2) || "N/A"}%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* <div className="hero-stats">
                      <div className="stats-grid">
                        <div className="stat-item highlight">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faChartPie} />
                          </div>
                          <div className="stat-label">Total Products</div>
                          <div className="stat-value">{categorySummary?.total_funds || "N/A"}</div>
                        </div>
                        
                        <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faBuilding} />
                          </div>
                          <div className="stat-label">Total AMC's</div>
                          <div className="stat-value">{categorySummary?.amc_count || "N/A"}</div>
                        </div>
                        
                        <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faCalendarAlt} />
                          </div>
                          <div className="stat-label">Latest Launch</div>
                          <div className="stat-value">{formatDate(categorySummary?.latest_launch_date) || "N/A"}</div>
                        </div>
                      </div>
                    </div> */}
                    </>
                  ))}
                </>
              );

            case 'productList':
              return config.showProductList && (
                <>
                <div key="productList" style={{clear: 'both', marginBottom: '20px'}}>
                  <MMProductList config={config} hasInvestmentCategory={hasInvestmentCategory} />
                </div>
                {((config.showCategoryStats) && hasInvestmentCategory ? (
                  <div className="hero-stats">
                    <div className="stats-grid">
                        
                        <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faChartLine} /> 1Y Returns
                          </div>
                          {/* <div className="stat-label">1Y Returns</div> */}
                          <div className={`stat-value ${categorySummary?.returns_1yr > 0 ? 'positive' : 'negative'}`}>
                            {categorySummary?.returns_1yr?.toFixed(2) || "N/A"}%
                            {categorySummary?.returns_1yr > 0 ? 
                              <span className="stat-trend up">↑</span> : 
                              <span className="stat-trend down">↓</span>
                            }
                          </div>
                        </div>

                        <div className="stat-item highlight">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faChartArea} /> 3Y Returns
                          </div>
                          {/* <div className="stat-label">3Y Returns</div> */}
                          <div className={`stat-value ${categorySummary?.returns_3yr > 0 ? 'positive' : 'negative'}`}>
                            {categorySummary?.returns_3yr?.toFixed(2) || "N/A"}%
                            {categorySummary?.returns_3yr > 0 ? 
                              <span className="stat-trend up">↑</span> : 
                              <span className="stat-trend down">↓</span>
                            }
                          </div>
                        </div>

                        <div className="stat-item">
                          <div className="stat-icon">
                            <FontAwesomeIcon icon={faChartBar} /> 5Y Returns
                          </div>
                          {/* <div className="stat-label">5Y Returns</div> */}
                          <div className={`stat-value ${categorySummary?.returns_5yr > 0 ? 'positive' : 'negative'}`}>
                            {categorySummary?.returns_5yr?.toFixed(2) || "N/A"}%
                            {categorySummary?.returns_5yr > 0 ? 
                              <span className="stat-trend up">↑</span> : 
                              <span className="stat-trend down">↓</span>
                            }
                          </div>
                        </div>

                        </div>
                      </div>
                ) : (
                  <></>
                ))}
                </>
              );

            case 'description':
              return config.showDescription && categoryData.long_description && (
                <div key="description" style={{ clear: 'both' }}>
                  <p dangerouslySetInnerHTML={{ __html: categoryData.long_description || '' }} />
                </div>
              );

            case 'whyNecessary':
              return config.showWhyNecessary && categoryData.why_necessary_content && (
                <div 
                  key="whyNecessary"
                  className="why-necessary-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.why_necessary_content }}
                />
              );
            case 'whyUs':
              return config.showWhyUs && categoryData.why_us_content && (
                <div 
                  key="whyUs"
                  className="why-us-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.why_us_content }}
                />
              );
            case 'investmentSpread':
              return config.showInvestmentSpread && categoryData.investment_spread_content && (
                <div 
                  key="investmentSpread"
                  className="investment-spread-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.investment_spread_content }}
                />
              );
            case 'expertManagers':
              return config.showExpertManagers && categoryData.expert_managers_content && (
                <div 
                  key="expertManagers"
                  className="expert-managers-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.expert_managers_content }}
                />
              );
            case 'connect':
              return config.showConnect && categoryData.connect_content && (
                <div 
                  key="connect"
                  className="connect-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.connect_content }}
                />
              );
            case 'benefits':
              return config.showBenefits && categoryData.benefits_content && (
                <div 
                  key="benefits"
                  className="benefits-section"
                  dangerouslySetInnerHTML={{ __html: categoryData.benefits_content }}
                />
              );
            case 'nfoList':
              return config.showNFOList && (
                <div className="widget-wrapper">
                  <NFOList config={config} />
                </div>
              );
            {/* case 'indexChart':
              return config.showIndexChart && (
                <div className="widget-wrapper">
                  <IndexChart config={config} />
                </div>
              ); */}
            default:
              return null;
          }
        })}
      </div>
    );
  }
}

const CustomCategoryBreadcrumb = ({ categories, currentCategory, config }) => {
  const breadcrumbs = [
    <a key="home" href={config.siteUrl}>Home</a>
  ];

  if (categories && categories.length > 0) {
    categories.forEach((category, index) => {
      breadcrumbs.push(
        <span key={category.category_code}>
          {' » '}
          {category.custom_url && 
            <a href={`${category.custom_url}`}>
              {category.category_name || category.name || ""}
            </a>
          }
          {!category.custom_url && 
            <a href={`${config.siteUrl}/category/${category.category_code}`}>
              {category.name}
            </a>
          }
        </span>
      );
    });
  }

  if (currentCategory) {
    breadcrumbs.push(
      <span key={currentCategory.category_code}>
        {' » '}
        {currentCategory.name}
      </span>
    );
  }

  return (
    <div className="custom-breadcrumb">
      {breadcrumbs}
    </div>
  );
};


export default MMCategoryBlock;
